import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { MemberService } from 'src/app/service/member-service/member.service';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-member-detail-modal',
  templateUrl: './member-detail-modal.component.html',
  styleUrls: ['./member-detail-modal.component.css']
})
export class MemberDetailModalComponent implements OnInit, OnDestroy {
  @Input() memberId: string;
  @Output() onCloseModal = new EventEmitter<any>();

  memberData: any;
  losTitle: string = 'N/A';
  spaceTypeTitle: string = 'N/A';
  isLoading: boolean = false;

  constructor(
    private memberService: MemberService,
    private assignTripService: AssigTripsService
  ) { }

  ngOnInit() {
    if (this.memberId) {
      this.getMember(this.memberId);
    }
  }

  getMember(memberId) {
    this.isLoading = true;
    this.memberService
      .getMemberById(memberId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          this.isLoading = false;
          if (data) {
            this.memberData = data;
            this.resolveConfigurations();
          }
        },
        (err) => {
          this.isLoading = false;
          sweetAlert('Error', 'Failed to fetch member details', 'warning', 'OK');
        }
      );
  }

  resolveConfigurations() {
    this.assignTripService
      .getConfigurations({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (config) => {
          if (config && this.memberData) {
            if (config.levelofservices && config.levelofservices.length) {
              const matchedLos = config.levelofservices.find((item) => item._id === this.memberData.los);
              this.losTitle = matchedLos ? matchedLos.title : 'N/A';
            }
            if (config.spacetypes && config.spacetypes.length) {
              const matchedSpaceType = config.spacetypes.find((item) => item._id === this.memberData.spaceType);
              this.spaceTypeTitle = matchedSpaceType ? matchedSpaceType.title : 'N/A';
            }
          }
        },
        (err) => {
          console.error('Error fetching configurations:', err);
        }
      );
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  ngOnDestroy(): void {
  }
}
